import Vue,{ createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import  Antd from "ant-design-vue"
import 'ant-design-vue/dist/antd.css';
import { message} from 'ant-design-vue'
// import "default-passive-events";
import axios from "axios";
// 引入全部图标
import * as Icons from "@ant-design/icons-vue";
const icons: any = Icons;
// @ts-ignore
// import VideoPlayer from "vue-video-player";
// import "vue-video-player/src/custom-theme.css";
// import "video.js/dist/video-js.css";
// 引入 hls,视频直播(m3u8)必须引入的
// import 'videojs-contrib-hls'
// 播放rtmp视频
// import 'videojs-flash'

// import 'vue-video-player/src/custom-theme.css'
// import 'video.js/dist/video-js.css'
// 这个是为了兼容 m3u8
// const hls = require('videojs-contrib-hls')

const app = createApp(App);
app.config.globalProperties.$http = axios;
app.config.globalProperties.$message = message //全局提示
// vue3.x废除了过滤器,可以使用此方法
app.config.globalProperties.$filters = {
  timeToDate(val:any){
    if(val!=null){
      return val.toString().split(' ')[0]
    }
  }
}
  app.use(store)
  .use(router)
  .use(Antd)
  .mount("#app");

  // 全局注册icons
Object.keys(icons).forEach(key => {
  app.component(key, icons[key]);
});
app.config.globalProperties.$icons = icons;